const TEST_USER_IDS = new Set(['810005363861', '810005831129']);

export default function canSendChallenge(args: { rank?: number; uid?: string }) {
  if (args.uid && TEST_USER_IDS.has(args.uid)) return true;
  return args.rank && args.rank > 0 && args.rank < 21;
}
